var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('p',{staticClass:"title font-weight-bold ma-0"},[_vm._v("Reports")])])],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }